import { Box, Row, Col, Section, Spacer, Table } from 'components/atoms/Grid';
import { Image } from 'components/atoms/Image';
import { ItemList } from 'components/atoms/ItemList';
import { SimpleLink } from 'components/atoms/Link';
import { Typography } from 'components/atoms/Typography';
import { InteractiveChart } from 'components/organisms/InteractiveChart';
import { InteractiveMap } from 'components/organisms/InteractiveMap';

export const keysToComponentMap = {
    box: Box,
    section: Section,
    row: Row,
    typography: Typography,
    list: ItemList,
    simpleLink: SimpleLink,
    col: Col,
    image: Image,
    spacer: Spacer,
    interactiveMap: InteractiveMap,
    interactiveChart: InteractiveChart,
    table: Table,
};
